import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=2b2ac924&"
import script from "./Sidebar.vue?vue&type=script&lang=ts&"
export * from "./Sidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b2ac924')) {
      api.createRecord('2b2ac924', component.options)
    } else {
      api.reload('2b2ac924', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=2b2ac924&", function () {
      api.rerender('2b2ac924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/layout/thirdparty/Sidebar.vue"
export default component.exports